import { makeApiRequests } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';

export const statusOrderServices = {
  getStatusOrder: async signal => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.STATUS_ORDER,
      method: 'GET',
      signal
    });
    return { response, error };
  },

  createOrUpdateStatusOrder: async (requestBody, signal) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.STATUS_ORDER,
      requestBody,
      method: 'POST',
      signal
    });
    return { response, error };
  }
};
